import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';

import Moment from 'moment'
Moment.locale('fr')

import {
  Box,
  Button,
} from '@material-ui/core';

import SuperAdminContext from "../../../../contexts/SuperAdminContext"

import APIS from "../../../../utils/APIS"

const FormationCard = ({formation}) => {
  const navigate = useNavigate()

  const { setOverlayForSave, setContents } = useContext(SuperAdminContext)

  const duplicateFormation = () => {
    setOverlayForSave(true)
    let duplicate = JSON.parse(JSON.stringify(formation))
    duplicate.icebreaker = formation?.icebreaker
    duplicate.name = formation?.name+"_COPIE"
    duplicate.surname = formation?.surname+"_COPIE"
    duplicate.feedbackTitle = formation?.feedbackFin?.titre
    duplicate.feedbackFormID = formation?.feedbackFin?.formulaire
    duplicate.feedbackSeuil = formation?.feedbackFin?.seuil
    duplicate.feedbackBtnType = formation?.feedbackFin?.button?.type
    duplicate.feedbackBtnText = formation?.feedbackFin?.button?.text
    duplicate.feedbackSucces = formation?.feedbackFin?.succes
    duplicate.feedbackFail = formation?.feedbackFin?.fail

    APIS.addContent(duplicate).then((result) => {
      if (result?.id && result?.formations) {
        setContents(result?.formations)
        navigate('/admin/formation/player/'+result?.id)
        setOverlayForSave(false)
      }
    })
  }

  return (
    <Box
      sx={{
        position: "relative",
        width:"calc(50% - 15px)",
        overflow:"hidden",
        boxShadow: "#5a5a5a4a 0 0 10px",
        borderRadius: "5px",
        color: "black",
        textDecoration: "none",
        cursor: "pointer",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        background:"white",
      }}
      onClick={() => {
        navigate('/admin/formation/edit/'+formation?.id)
      }}
    >
      <Box style={{
        marginBottom: "20px",
        display:"flex",
        justifyContent:"space-between",
        gap:"10px",
      }}>
        <Box sx={{overflow:"hidden"}}>
          <Box sx={{
            fontSize:"17px",
            color:"text.black",
            fontWeight:"bold",
            whiteSpace:"noWrap",
            overflow:"hidden",
            textOverflow:"ellipsis",
          }}>
            {formation?.name}
          </Box>
          <Box sx={{
            paddingTop: "5px",
            fontSize:"14px",
            color:"text.subTitle",
            whiteSpace:"noWrap",
            overflow:"hidden",
            textOverflow:"ellipsis",
          }}>
            {formation?.surname}
          </Box>
        </Box>
        <Button
          variant="contained"
          size="small"
          sx={{minHeight:"30px !important", height:"30px !important", fontSize:"14px !important", flexShrink:0}}
          onClick={(e) => {
            e.stopPropagation()
            duplicateFormation()
          }}
        >
          Dupliquer
        </Button>
      </Box>
      <Box sx={{
        display:'flex',
        justifyContent:'space-between'
      }}>
        <Box style={{ fontWeight: 'bold', fontSize: '12px', fontWeight: 300, marginTop: '15px', color:'red' }}>
          {formation?.archived === "true" &&
            <>{'Module archivé'}</>
          }
        </Box>
        <Button
          variant="contained"
          size="small"
          sx={{minHeight:"35px !important", height:"35px !important", fontSize:"14px !important"}}
          onClick={(e) => {
            e.stopPropagation()
            navigate('/admin/formation/player/'+formation?.id)
          }}
        >
          Player
        </Button>
      </Box>
    </Box>
  )
};

export default FormationCard;
